module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "assignment"
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.task ? _vm.task.name : ''))])]), (_vm.state === _vm.STATES.calibrate) ? _c('calib-page', {
    attrs: {
      "texts": _vm.introTexts
    },
    on: {
      "close": _vm.calibrate
    }
  }) : _vm._e(), (_vm.intro) ? _c('start-page', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state === _vm.STATES.start),
      expression: "state === STATES.start"
    }],
    attrs: {
      "texts": _vm.introTexts,
      "task": _vm.task,
      "student": _vm.student
    },
    on: {
      "close": _vm.startPageClosed,
      "saved": _vm.gazeDataSaved
    }
  }) : _vm._e(), (_vm.state === _vm.STATES.questionnaire) ? _c('questionnaire-page', {
    attrs: {
      "questionnaire": _vm.task.questionnaire,
      "longGazedWords": _vm.longGazedWords
    },
    on: {
      "finished": _vm.questionnaireDone
    }
  }) : _vm._e(), (_vm.state === _vm.STATES.finished) ? _c('finished-page', {
    attrs: {
      "texts": _vm.introTexts,
      "saving": !_vm.isDataSaved
    }
  }) : _vm._e(), _c('modal-error', {
    attrs: {
      "text": _vm.errorText
    },
    on: {
      "close": _vm.exit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cb43a53"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/Assignment.vue
// module id = 405
// module chunks = 0